import type { NavItem } from '@/modules/admin/stores/admin-nav';

/** Sidebar items for Expert Commentary admin (empty until section needs sub-nav). */
export const navItems: NavItem[] = [];
